import List from 'containers/Events/List';
import Edit from 'containers/Events/Edit';
import Create from 'containers/Events/Create';
import Show from 'containers/Events/Show';

export default { List, Edit, Create, Show };
